export const Styles = {
  titleContainer: {
    margin: "30px auto 15px",
  },
  backIcon: {
    cursor: "pointer",
  },
  spanContainer: {
    marginLeft: 10,
  },
  typography: {
    textAlign: "left",
    lineHeight: "1",
  },
  p: {
    margin: 0,
    textAlign: "left",
    color: "#7B7B7B",
    fontSize: "13px",
  },
  addSiteText: {
    fontWeight: "400",
    color: "black",
  },
  subTitleContainer: {
    paddingLeft: 35,
  },
  siteTitle: {
    fontSize: 17,
    fontWeight: "500",
  },
  siteSubTitle: {
    fontSize: 12,
    color: "#CACACA",
  },
  hr: {
    borderTop: "solid 1px #e2e2e2",
  },
  addSite: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    marginTop: 15,
    color: "#1492E6",
    cursor: "pointer",
    fontWeight: "500",
  },
  addIcon: {
    fontSize: "1rem",
    height: "1rem",
    width: "1rem",
    marginLeft: 5,
  },
};

// export const Styles = {
//   titleContainer: {
//     padding: "2px 24px",
//     // background: "#fff",
//     // borderBottom: "1px solid #e0e0e0",
//   },
//   backIcon: {
//     fontSize: 24,
//     cursor: "pointer",
//     marginRight: 12,
//   },
//   spanContainer: {
//     display: "flex",
//     flexDirection: "column",
  
//   },
//   typography: {
//     fontWeight: "bold",
//     marginBottom: 4,
//   },
//   p: {
//     margin: 0,
//     fontSize: 13,
//     color: "#555",
//   },
//   addSiteText: {
//     marginLeft: 5,
//     fontWeight: 500,
//   },
// };
